import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { useStore } from 'store/store';
import { OtpConfirmType } from '@/features/bill-payment/enum';
import { TWOFAWebScreen } from '@/features/bill-payment/screens/union-pay/TWOFAWeb.screen';
import { TWOFANativeScreen } from '@/features/bill-payment/screens/union-pay/TWOFANative.screen';
import { TWOFASmsWebScreen } from '@/features/bill-payment/screens/union-pay/TWOFASmsWeb.screen';
import { TWOFASmsNativeScreen } from '@/features/bill-payment/screens/union-pay/TWOFASmsNative.screen';

export interface TWOFAScreenProps {}

export const TWOFAScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.TWOFA>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const {
    onLayout,
    onBack,
    wallet,
    calcFee,
    beneficiaryInformation,
    onChangeView,
    unionType,
    refresh,
    navigationNavigate,
    navigationScreen
  } = route.params;

  const store = useStore();
  const mode = store.users && store.users.tfaKeyStatus ? OtpConfirmType.GOOGLE_OTP : OtpConfirmType.SMS_OTP;

  if (layout.isMobile) {
    if (mode == OtpConfirmType.GOOGLE_OTP)
      return (
        <TWOFANativeScreen
          onBack={onBack}
          wallet={wallet}
          calcFee={calcFee}
          beneficiaryInformation={beneficiaryInformation}
          unionType={unionType}
          refresh={refresh}
          navigationNavigate={navigationNavigate}
          navigationScreen={navigationScreen}
        />
      );
    else
      return (
        <TWOFASmsNativeScreen
          onBack={onBack}
          wallet={wallet}
          calcFee={calcFee}
          beneficiaryInformation={beneficiaryInformation}
          unionType={unionType}
          refresh={refresh}
          navigationNavigate={navigationNavigate}
          navigationScreen={navigationScreen}
        />
      );
  }

  if (mode == OtpConfirmType.GOOGLE_OTP)
    return (
      <TWOFAWebScreen
        onLayout={onLayout}
        onBack={onBack}
        wallet={wallet}
        calcFee={calcFee}
        beneficiaryInformation={beneficiaryInformation}
        onChangeView={onChangeView}
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
  else
    return (
      <TWOFASmsWebScreen
        onLayout={onLayout}
        onBack={onBack}
        wallet={wallet}
        calcFee={calcFee}
        beneficiaryInformation={beneficiaryInformation}
        onChangeView={onChangeView}
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
};
